<script>
  import {
    DataTable,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    Modal as DangerModal,
  } from "carbon-components-svelte";
  import {
    Pagination,
    Button,
    Select,
    SelectItem,
    TextInput,
  } from "paxray-components-svelte";
  import { COPY_ICON, EDIT_ICON, TRASH_ICON } from "@utils/icons.js";
  import Modal from "../../../../lib/components/Modal.svelte";
  import { isValidRegex } from "../../../../lib/util/regex.js";
  import CopyToClipboardButtons from "./CopyToClipboardButtons.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  export let idAnonymization;
  export let editable = false;
  export let currentAnonymizationRule = {};
  export let uilistfilterelements = {};
  export let anonymizationRuleModalOpen = false;
  let anonymizationRules = [];
  let rulesToDisplay = [];
  let page = 1;
  let pageSize = 10;
  let filteredRowIds = [];
  let valueFilter = "";

  let isSaveDisabled = true;
  let isAutomationSearchInvalid = false;
  let isAutomationReplaceInvalid = false;
  let isNameSearchInvalid = false;
  let isNameReplaceInvalid = false;
  let seeTable = true;
  let tempRuleName = "";
  let nameprefix = "";

  let deleteConfirmationModalOpen = false;
  let idToDelete = null;

  $: {
    if (idAnonymization) {
      fetchWithSession(
        `/api/damprojects/DAMAnonymizationRulesUI/${idAnonymization}`,
      )
        .then((res) => res.json())
        .then((data) => {
          anonymizationRules = data.items;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  $: currentAnonymizationRule, nameprefix, validateForm();

  $: rulesToDisplay =
    valueFilter.trim() === ""
      ? anonymizationRules
      : anonymizationRules.filter(
          (rule) =>
            rule.name &&
            rule.name.toLowerCase().includes(valueFilter.toLowerCase()),
        );

  function validateForm() {
    isAutomationSearchInvalid = !isValidRegex(
      currentAnonymizationRule.automationsearch,
    );
    isAutomationReplaceInvalid = !isValidRegex(
      currentAnonymizationRule.automationreplace,
    );
    isNameSearchInvalid = !isValidRegex(currentAnonymizationRule.namesearch);
    isNameReplaceInvalid = !isValidRegex(currentAnonymizationRule.namereplace);
    isSaveDisabled =
      isAutomationSearchInvalid ||
      isAutomationReplaceInvalid ||
      isNameSearchInvalid ||
      isNameReplaceInvalid;

    tempRuleName =
      nameprefix +
      " - " +
      currentAnonymizationRule.applicationname +
      " - " +
      (currentAnonymizationRule.elementclass
        ? currentAnonymizationRule.elementclass + " - "
        : "") +
      (currentAnonymizationRule.type
        ? currentAnonymizationRule.type + " - "
        : "") +
      (currentAnonymizationRule.automationreplace
        ? currentAnonymizationRule.automationreplace + " - "
        : "") +
      (currentAnonymizationRule.namereplace
        ? currentAnonymizationRule.namereplace
        : "");
  }

  function checkRequiredFields(rule) {
    return (
      !rule.name ||
      earch ||
      !rule.automationreplace ||
      !rule.namesearch ||
      !rule.namereplace ||
      !rule.applicationname ||
      !rule.elementclass ||
      !rule.type
    );
  }

  function editAnonymizationRule(id, duplicate = false) {
    if (id != 0) {
      currentAnonymizationRule = {
        ...anonymizationRules.find((x) => x.id == id),
      };
      if (duplicate) {
        currentAnonymizationRule.id = 0;
        id = 0;
      }
    } else {
      currentAnonymizationRule = {
        id: 0,
        name: "",
        automationsearch: "",
        automationreplace: "",
        namesearch: "",
        namereplace: "",
        applicationname: "*",
        elementclass: "*",
        type: "*",
      };
    }
    anonymizationRuleModalOpen = true;
  }

  function saveAnonymizationRule() {
    // if (!currentAnonymizationRule.name)
    currentAnonymizationRule.name = tempRuleName;
    let payload = {
      idanonymizationrules: idAnonymization,
      ...currentAnonymizationRule,
    };
    fetchWithSession(`/api/damprojects/saveDAMAnonymizationRuleUI`, {
      method: "POST",
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          if (currentAnonymizationRule.id === 0) {
            currentAnonymizationRule.id = data.id;
            currentAnonymizationRule.idanonymizationrules = idAnonymization;
            anonymizationRules = [
              ...anonymizationRules,
              currentAnonymizationRule,
            ];
          } else {
            anonymizationRules = anonymizationRules.map((rule) =>
              rule.id === data.id ? currentAnonymizationRule : rule,
            );
          }
        }
        anonymizationRuleModalOpen = false;
      });
  }

  function confirmDeletePreprocessingStep(id) {
    idToDelete = id;
    deleteConfirmationModalOpen = true;
  }

  function deletePreprocessingStepConfirmed() {
    fetchWithSession(
      `/api/damprojects/deleteDAMAnonymizationRuleUI/${idToDelete}`,
      {
        method: "POST",
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          anonymizationRules = anonymizationRules.filter(
            (x) => x.id != idToDelete,
          );
          deleteConfirmationModalOpen = false;
        }
      });
  }
</script>

<div class="table_wrapper">
  <DataTable
    size="short"
    headers={[
      { key: "name", value: "Name" },
      { key: "automationsearch", value: "Search" },
      { key: "automationreplace", value: "Replace" },
      { key: "namesearch", value: "Name Search" },
      { key: "namereplace", value: "Name Replace" },
      { key: "applicationname", value: "Application" },
      { key: "elementclass", value: "Class" },
      { key: "type", value: "Type", width: "150px" },
      { key: "menu", empty: true, width: "150px" },
    ]}
    rows={rulesToDisplay}
    sortable
    {page}
    {pageSize}
  >
    {#if editable}
      <Toolbar>
        <ToolbarContent>
          <ToolbarSearch shouldFilterRows bind:value={valueFilter}
          ></ToolbarSearch>
          <Button
            text="Add Rule"
            kind="secondary"
            on:click={() => {
              editAnonymizationRule(0);
            }}
          />
        </ToolbarContent>
      </Toolbar>
    {/if}
    <svelte:fragment slot="cell" let:cell let:row>
      {#if cell.key === "menu" && editable}
        <Button
          size="small"
          kind="secondary"
          icon={EDIT_ICON}
          on:click={editAnonymizationRule(row.id)}
          iconDescription="Edit"
        />
        <Button
          size="small"
          kind="secondary"
          icon={COPY_ICON}
          on:click={editAnonymizationRule(row.id, true)}
          iconDescription="Duplicate"
        />
        <Button
          size="small"
          kind="danger"
          icon={TRASH_ICON}
          on:click={confirmDeletePreprocessingStep(row.id)}
          iconDescription="Delete"
        />
      {:else if cell.key !== "menu"}
        {cell.value}
      {/if}
    </svelte:fragment>
  </DataTable>
  <Pagination
    dark
    bind:page
    bind:pageSize
    pageSizes={[10, 25, 50]}
    totalItems={rulesToDisplay.length}
  />
</div>

<DangerModal
  danger
  bind:open={deleteConfirmationModalOpen}
  preventCloseOnClickOutside
  modalHeading="Delete Rule"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => (deleteConfirmationModalOpen = false)}
  on:click:button--primary={deletePreprocessingStepConfirmed}
>
  <p>This is a permanent action and cannot be undone.</p>
</DangerModal>

<Modal
  autowidth
  bind:open={anonymizationRuleModalOpen}
  actions
  preventCloseOnClickOutside
  modalHeading="Application"
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    anonymizationRuleModalOpen = false;
  }}
  on:open
  on:close={() => {
    anonymizationRuleModalOpen = false;
  }}
  primaryButtonAction={saveAnonymizationRule}
  primaryButtonNotAllow={isSaveDisabled}
>
  <CopyToClipboardButtons />
  <TextInput
    labelText="Prefix"
    placeholder="Enter Prefix"
    bind:value={nameprefix}
  />
  <TextInput
    labelText="Name"
    placeholder={tempRuleName}
    value={tempRuleName}
    readonly
  />
  Automation ID <br />
  <table style="width:100%">
    <tr>
      <td>
        <TextInput
          labelText="Search"
          placeholder="Enter Search String (regex allowed)"
          bind:value={currentAnonymizationRule.automationsearch}
          invalid={isAutomationSearchInvalid}
        />
      </td>
      <td>
        <TextInput
          labelText="Replace"
          placeholder="Enter Replacement (regex allowed)"
          bind:value={currentAnonymizationRule.automationreplace}
          invalid={isAutomationReplaceInvalid}
        />
      </td>
    </tr>
  </table>
  Name<br />
  <table style="width:100%">
    <tr>
      <td>
        <TextInput
          labelText="Search"
          placeholder="Enter Search String (regex allowed)"
          bind:value={currentAnonymizationRule.namesearch}
          invalid={isNameSearchInvalid}
        />
      </td>
      <td>
        <TextInput
          labelText="Replace"
          placeholder="Enter Replacement (regex allowed)"
          bind:value={currentAnonymizationRule.namereplace}
          invalid={isNameReplaceInvalid}
        />
      </td>
    </tr>
  </table>
  <Select
    labelText="Application"
    bind:selected={currentAnonymizationRule.applicationname}
  >
    <SelectItem value="*" text="All Applications" />
    {#each uilistfilterelements.applicationname as applicationname}
      <SelectItem value={applicationname} text={applicationname} />
    {/each}
  </Select>
  <Select labelText="Type" bind:selected={currentAnonymizationRule.type}>
    <SelectItem value="*" text="All Types" />
    {#each uilistfilterelements.type as type}
      <SelectItem value={type} text={type} />
    {/each}
  </Select>
  <Select
    labelText="Class"
    bind:selected={currentAnonymizationRule.elementclass}
  >
    <SelectItem value="*" text="All Classes" />
    {#each uilistfilterelements.elementclass as elementclass}
      <SelectItem value={elementclass} text={elementclass} />
    {/each}
  </Select>
</Modal>

<style>
  .table_wrapper {
    display: flex;
    flex-direction: column;
  }
</style>
